import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center h-screen bg-surface-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-surface-600"
}, "이메일", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-surface-600"
}, "비밀번호", -1)

import { ref } from "vue";
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: {
  title: {
    type: String,
    required: true,
  },
  submitLabel: {
    type: String,
    required: true,
  },
  footerLink: {
    type: String,
    required: true,
  },
  footerText: {
    type: String,
    required: true,
  },
},
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const email = ref("");
const password = ref("");

const handleSubmit = () => {
  emit("submit", { email: email.value, password: password.value });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "w-full max-w-md" }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.title), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-4"
        }, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(_unref(InputText), {
              id: "email",
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_unref(Password), {
              id: "password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              feedback: false,
              toggleMask: "",
              class: "w-full",
              inputClass: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            type: "submit",
            label: props.submitLabel,
            class: "w-full"
          }, null, 8, ["label"])
        ], 32)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: props.footerLink,
          class: "text-primary-600 hover:underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.footerText), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    })
  ]))
}
}

})